import {keyBy} from 'lodash';

import {
  accountType,
  activityType,
  autolinkerType,
  booleanType,
  circleType,
  commentType,
  contactType,
  conversationType,
  dataTableType,
  dateTimeType,
  emailType,
  inboxType,
  jsonType,
  listType,
  messageType,
  numberType,
  previewerType,
  stringType,
  tagType,
  teammateType,
  topicType,
  unknownType,
  urlType,
} from './internal';

export const allTypes = keyBy(
  [
    stringType,
    emailType,
    urlType,
    numberType,
    booleanType,
    dateTimeType,
    listType,
    teammateType,
    inboxType,
    tagType,
    topicType,
    contactType,
    accountType,
    conversationType,
    messageType,
    commentType,
    activityType,
    autolinkerType,
    previewerType,
    jsonType,
    circleType,
    dataTableType,
    unknownType,
  ],
  (type) => type.name,
);
